var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArchive = function SvgArchive(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 11v3.2l-.9-.9a.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275.95.95 0 0 0-.275.7q0 .425.275.7l2.6 2.6q.3.3.7.3t.7-.3l2.6-2.6a.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275l-.9.9V11a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 10M5 8v11h14V8zm0 13q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V6.525q0-.35.112-.675.113-.325.338-.6L4.7 3.725q.274-.35.688-.538Q5.8 3 6.25 3h11.5q.45 0 .863.188.412.187.687.537l1.25 1.525q.225.274.337.6t.113.675V19q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm.4-15h13.2l-.85-1H6.25z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArchive);
export { ForwardRef as ReactComponent };